module.exports = __webpack_public_path__ + "img/project2.0ccb9881.png";